import { push } from 'react-router-redux';
import * as api from '../api';
import { ssgFormActions } from '@social-solutions/ssg-forms';

const fetchCurrentSessionActions = api.fetchActions('auth', 'fetch-current-session');
export const fetchParticipantInfoActions = api.fetchActions('auth', 'fetch-participant-info');

export const actionTypes = {
  SET_SESSION: 'auth.set-session',
  ...fetchCurrentSessionActions.actionTypes,
  ...fetchParticipantInfoActions.actionTypes,
  DELETE_CURRENT_SESSION_SUCCESS: 'auth.delete-current-session-success',
  DELETE_CURRENT_SESSION_FAILURE: 'auth.delete-current-session-failure',
  INVALIDATE_CURRENT_SESSION: 'auth.invalidate-current-session',
  INVALIDATE_CURRENT_SESSION_UNOBTRUSIVE: 'auth.invalidate-current-session-unobtrusive',
  REVOKE_ACCESS: 'auth.revoke-access',
  LOGOUT: 'auth.logout',
  LOGOUT_RESET: 'auth.logout-reset'
};

export const fetchCurrentSession = () => api.getThunk('/sessions/current', null, fetchCurrentSessionActions);
export const fetchParticipantInfo = () => api.getThunk('/participants/current', null, fetchParticipantInfoActions);

export function setSession(session) {
  return {
    type: actionTypes.SET_SESSION,
    session
  }
}

export function redirectToLogin(returnUrl) {
  return (dispatch) => dispatch(push(`/login?redirectUrl=${returnUrl}`));
}

export function redirectTo(returnUrl) {
  return (dispatch) => dispatch(push(returnUrl || '/'));
}

export function getCurrentSessionFromSecureToken(secureToken) {
  return (dispatch) => {
    dispatch(setBearerAuth(secureToken));
    return dispatch(fetchCurrentSession());
  }
}

/** reset justLoggedOut flag. should be triggered if user logs in to the portal */
export function logoutReset(){
  return {
    type: actionTypes.LOGOUT_RESET
  }
}

export function logout() {
  return (dispatch) => {
    dispatch(logoutBegin());
    dispatch(deletecurrentSessions());
    dispatch(ssgFormActions.hardReset('view-demographics'));
    dispatch(ssgFormActions.hardReset('edit-demographics'));
    dispatch(ssgFormActions.resetForm("login-form-response"));
  }
}

function logoutBegin() {
  return {
    type: actionTypes.LOGOUT
  }
}

function deletecurrentSessions() {
  return (dispatch) => {
    api.httpDelete('/sessions/current')
      .then(() => {
        dispatch(push('/login'));
      })
      .then(() => {
        dispatch(deleteCurrentSessionSuccess());
      })
      .catch(err => {
        dispatch(deleteCurrentSessionFailure(err));
        throw err;
      });
  }
}

function deleteCurrentSessionSuccess() {
  return {
    type: actionTypes.DELETE_CURRENT_SESSION_SUCCESS
  }
}

function deleteCurrentSessionFailure(err) {
  return {
    type: actionTypes.DELETE_CURRENT_SESSION_FAILURE,
    err
  }
}

export function invalidateCurrentSession() {
  return {
    type: actionTypes.INVALIDATE_CURRENT_SESSION
  }
}

export function invalidateCurrentSessionUnobtrusive() {
  return {
    type: actionTypes.INVALIDATE_CURRENT_SESSION_UNOBTRUSIVE
  }
}

function invalidateCurrentSessionAccessRevoked(err) {
  return {
    type: actionTypes.REVOKE_ACCESS,
    err
  }
}

function setBearerAuth(secureToken) {
  return (dispatch) => {
    api.config.unauthorizedGetNotifier = () => {
      dispatch(invalidateCurrentSession());
    }
    api.config.unauthorizedPostNotifier = () => {
      dispatch(invalidateCurrentSessionUnobtrusive());
    }
    api.config.revokeAccessNotifier = (err) => {
      dispatch(invalidateCurrentSessionAccessRevoked(err));
    }
  }
}



// WEBPACK FOOTER //
// src/auth/auth.actions.js